<template>
    <div>
        <div class="blog_block">
            <CommonBreadcrumb class="my-3" />
        </div>
        <section class="blog_block">
            <div class="row blog_upper_block">
                <div class="col-lg-4 col-md-3 col-12 for_desktop">
                    <div class="back_btn_blog">
                        <NuxtLink :to="localePath('/blog')"> BACK TO JOURNAL</NuxtLink>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-12">
                    <div class="post_under_blog">
                        <p class="mb-0">
                            Posted under 
                            <NuxtLink :to="localePath( { name: 'blog-listing', params: { type: 'category', sub_type: data.data.category_slug } } )">
                                <span class="radious_eight">{{ data.data.category_name }}</span>
                            </NuxtLink> 
                        </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-3 col-10">
                    <div class="date_blog">{{ data.data.created }}</div>
                </div>
            </div>
            <div class="blog_flex">
                <div class="sticky_div blog_box_side for_tablet">
                    <BlogDetailSocialShare :url="currentPage" />
                </div>
                
                <div v-if="data.data.description" class="blog_box_center">
                    <BlogDetailBlogContent :data="data.data" />
                    <div class="show_below">
                        <BlogDetailSocialShare :url="currentPage" />
                    </div>
                </div>
                <div class="sticky_div blog_box_side for_desktop">
                    <div class="art_container">
                        <BlogDetailRecentPost :data="data.data.recent_blogs" />
                    </div>
                </div>
            </div>
        </section>
        <div class="blog_block_mod">
            <section class="blog_block">
                <BlogDetailNextPrevious :data="data.data" />
            </section>
        </div>
        <section class="blog_block">
            <BlogDetailRelatedStory :data="data.data.recommend_blogs" />
        </section>
      
    </div>
</template>

<script setup>

    const runtimeConfig = useRuntimeConfig()
    const route = useRoute()
    const localePath = useLocalePath()
    const { $country } = useNuxtApp()

    const { data, error: fetchError } = await useFetch(() => useCountryPath(`/blog/${route.params.slug}`))
    
    if (fetchError.value) {
        if (fetchError.value.statusCode === 400 || fetchError.value.statusCode === 404) {
            throw createError({ statusCode: 404, message: 'Page not found',fatal:true })
        }
    }

    const currentPage = computed(() => {
        let url = ''
        if (import.meta.client) {
            url = window.location.href
        }
        return url
    })


    const metaTitle = computed(() => data.value.data.meta_title)

    const currentUrl = computed(() => {
  
        const domain = runtimeConfig.public.domain
        if ($country.location === 'US') {
            return domain + '/blog/' + data.value.data.slug
        }
        if ($country.location === 'IN') {
            return domain + '/in/blog/' + data.value.data.slug
        }

        return ''
    })

    const finalUrl = computed(() => {
        if ($country.location === 'US') {
            return currentUrl.value.replace('.com', '.com/in')
        }
        if ($country.location === 'IN') {
            return currentUrl.value.replace('.com/in', '.com')
        }
        return ''
    })

    useHead({
        title: metaTitle.value,
        meta: [
            { name: 'description', content: data.value.data.meta_desc },
            { name: 'keywords', content: data.value.data.meta_keyword },
            { property: 'og:title', content: metaTitle.value },
            { property: 'og:type', content: 'website' },
            { property: 'og:url', content: currentUrl.value },
            { property: 'og:description', content: data.value.data.meta_desc },
            { property: 'twitter:title', content: metaTitle.value },
            { property: 'og:image', content: data.value.data.bnr_image },
            { property: 'og:image:url', content: data.value.data.bnr_image },
            { property: 'og:image:type', content: 'image/jpeg' },
        ],
        link: [
            { rel: 'canonical', href: currentUrl.value },
            { rel: 'alternate', hreflang: 'en-' + $country.location, href: runtimeConfig.public.domain + route.path },
        ],
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": "https://www.friendlydiamonds.com/blog/" + data.value.data.slug
                    },
                    "headline": data.value.data.title,
                    "image": [data.value.data.image],
                    "datePublished": data.value.data.created,
                    "dateModified": data.value.data.created,
                    "author": {
                        "@type": "Person",
                        "name": data.value.data.author
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "Friendly Diamonds",
                        "logo": {
                            "@type": "ImageObject",
                            "url": "", // Add your logo URL here
                            "width": 600,
                            "height": 60
                        }
                    },
                    "description": data.value.data.meta_desc,
                    "articleBody": data.value.data.description
                })
            }
        ],
    })
  

</script>

<style scoped>
.show_below{
    display: none;
}

.blog_flex{
    display: flex;
}
.blog_box_side{
    width: 33%;
}
.blog_box_center{
    width: 33%;
}
.blog_block{
    max-width: 93%;
    margin: 0 auto;
}

.blog_block_mod {
    border-bottom: 1px solid #e2e2e2;
    padding: 3% 0;
}
.art_container {
    display: flex;
    justify-content: flex-end;
}
.back_btn_blog a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 14px;
    font-weight: 600;
}
.back_btn_blog a .svg-parent {
    height: 13px !important;
}
.back_btn_blog a span {
    margin-right: 17px;
}

.post_under_blog p {
    font-size: 14px;
    font-weight: 500;
}

.post_under_blog p span {
    text-transform: uppercase;
    border: 1px solid #000;
    padding: 3px 8px;
    margin-left: 8px;
}
.post_under_blog p a {
    color: #000;
}
.date_blog {
    text-align: right;
    font-size: 14px;
    font-weight: 500;
}

.blog_upper_block {
    margin-top: 32px;
    margin-bottom: 50px;

}
@media(max-width: 1500px){
    .blog_box_side{
        width: 30%;
    }
    .blog_box_center{
        width: 40%;
    }
}
@media(max-width: 1150px){
    .blog_box_side{
        width: 25%;
    }
    .blog_box_center{
        width: 50%;
    }
    .art_container {
        padding-left: 15%;
    }
  
}
@media(max-width: 992px){
    .show_below{
        display: block;
    }
    .blog_upper_block {
        margin-top: 32px;
        margin-bottom: 30px;
    }
    .for_tablet {
        display: none;
    }
    .blog_box_center{
        width: 65%;
    }
    .blog_box_side{
        width: 35%;
    }
}
@media(max-width: 767px){
    .date_blog {
        text-align: left;
        margin-top: 17px;
    }
    .blog_banner{
        text-align: center;
    }
    .blog_block_mod{
        border-bottom: 1px solid #e2e2e2;
        padding: 40px 0 20px;
        border-top: 1px solid #e2e2e2;
        margin: 0;
    }
    
    .blog_flex {
        flex-wrap: wrap;
    }

    .blog_box_side, .blog_box_center {
        width: 100%;
    }
    .blog_block{
        max-width: 100%;
        margin: 0 auto;
    }
    .blog_block{
        padding: 0 4%;
    }
 
}
@media(min-width: 768px){
    .sticky_div {
        position: sticky;
        position: sticky;
        top: 30px;
        height: fit-content;
    }
}
</style>